(function ( $ ) {
	
	"use strict";
	
	var retina = isRetina() ? '-x2' : '';
	var loadedClass = 'image-loaded';
	var loadingClass = 'image-loading';
	var imageSelector = '.jr-load-image';
	var images,
	onLoad = false;

	$(document).ready(function() {
		images = $(imageSelector);
		cycleThroughImages(images);


	});

	$(window).load(function() {
		onLoad = true;
		cycleThroughImages(images, true);
	});

	$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
		cycleThroughImages(images, true, true);
	});

	
	
	function cycleThroughImages($this, onLoad = false, force = false) {

		$this.each( function() {
			
			var $this = $(this);
			
			if (($this.hasClass(loadedClass) || $this.hasClass(loadingClass)) && !force) {
				return true;
			}

			var inView = isElementInViewport($this);
			
			if ((inView && !onLoad) || onLoad || force) {

				loadImage($this);
			}
			
		});
		
	}
	
	
	function loadImage($this) {

		var currentMediaQuery = Foundation.MediaQuery.current;
	
		var type = $this.data('image-type');
		
		var src = $this.data(currentMediaQuery + retina);

		if (typeof src === 'undefined') {
			
			return false;
			
		}
			
		var $image = $('<img/>').attr('src', src);

		$this.addClass(loadingClass);

		$image.on('load', function() {

			$(this).remove();

			if (type === 'background') {

				$this.css({
					'background-image' : 'url(' + src + ')' 
				}).addClass(loadedClass).removeClass(loadingClass);

			}

		});

	}
	
 
}( jQuery ));